import Debug from 'debug';
import Cig from '../util/Cig';
import buildCigObjectsUrl from "../util/cig-objects-url";
/**
 * Fired on the <pub-slug>?/my-account page
 */
export default {
	async init() {
		try {
			Debug(`cig:info:sage:route:myAccount`)(`init start`);

			// Get CIG Objects blob
			const url = await buildCigObjectsUrl('person', 'account.json');

			Cig.loadExternalScript(url, '#inline-my-account', () => console.log('CIG Objects Loaded'));

		} catch (err) {
			Debug(`cig:error:sage:route:myAccount`)(`My Account Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:myAccount`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:myAccount`)(`My Account Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},
};
